import { render } from "./WCSearchBarV2.vue?vue&type=template&id=32ea6c0c&scoped=true"
import script from "./WCSearchBarV2.vue?vue&type=script&lang=js"
export * from "./WCSearchBarV2.vue?vue&type=script&lang=js"

import "./WCSearchBarV2.vue?vue&type=style&index=0&id=32ea6c0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ea6c0c"]])

export default __exports__